<template>
    <div class="start-shopping">
        <div class="page-wrapper">
            <div class="page-contents">
                <div>
                    <h1 class="text-center">{{welcomeMessage}}!</h1>
                    <div class="partner-logo"><img :src="partnerLogo" /></div>
                    <div class="shopping-details">
                        <ul>
                            <li>Ultimate Deal Group</li>
                            <li>Glitches, price drops, and promo codes</li>
                            <li>Great deals for the whole family</li>
                            <li>Easy to use</li>
                        </ul>
                    </div>
                    <div class="text-center subtext" v-show="subtext">{{subtext}}!</div>
                    <p class="shopping-button-container" v-for="link in links" :key="link.url">
                        <a :href="link.url" target="_blank" class="button-link" id="deal-url" @click="trackOutboundLink(link.url)">
                            <button id="button-deal" class="button">{{link.text}}</button>
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import settings from '@/settings'

type Link = {
    url: string
    text: string
}

export default defineComponent({
    name: 'StartShopping',
    setup() {
        const route = useRoute()
        const welcomeMessage = ref<string | null>(null)
        const partnerLogo = ref<string | null>(null)
        const subtext = ref<string | null>(null)
        const links = ref<Link[] | null>(null)

        const trackOutboundLink = (url: string): void => {
            if (window.gtag) {
                window.gtag('event', 'click', {
                    'event_category': 'shopping',
                    'event_label': url,
                    'transport_type': 'beacon'
                })
            }
        }

        onMounted(() => {
            document.title = settings.siteNameCaps + ' | Shopping'

            switch (route.params.id) {
                case 'lnn':
                    partnerLogo.value = '/assets/img/LNN_logo.jpg'
                    welcomeMessage.value = "Welcome LNN Subscribers"
                    subtext.value = "Click to join MommyDeals on WhatsApp"
                    links.value = [
                        {
                            url: 'https://mommydeals.us/JoinWhatsapp',
                            text: 'Click to Join'
                        }
                    ]
                    break
                case 'machane':
                    welcomeMessage.value = "Welcome Machane Miami"
                    links.value = [
                        {
                            url: 'https://amzn.to/2S3N50S',
                            text: 'Go to Amazon'
                        },
                        {
                            url: 'https://goto.walmart.com/c/2006285/565706/9383?subId1=machanemiami&veh=aff&sourceid=imp_000011112222333344&u=http%3A%2F%2Fwww.walmart.com%3Fsourceid%3Dimp_%7Bclickid%7D%26veh%3Daff%26wmlspartner%3Dimp_%7Birpid%7D%26clickid%3D%7Bclickid%7D',
                            text: 'Go to Walmart'
                        },
                        {
                            url: 'https://goto.grocery.walmart.com/c/2006285/565706/9383?subId1=machane&veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fgrocery.walmart.com%2F',
                            text: 'Go to Walmart Grocery'
                        }
                    ]
                    break
                default:
                    welcomeMessage.value = "Welcome MommyDealer"
                    links.value = [
                        {
                            url: 'https://amzn.to/2RAOtcq',
                            text: 'Go to Amazon'
                        },
                        {
                            url: 'https://goto.walmart.com/c/2006285/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=http%3A%2F%2Fwww.walmart.com%3Fsourceid%3Dimp_%7Bclickid%7D%26veh%3Daff%26wmlspartner%3Dimp_%7Birpid%7D%26clickid%3D%7Bclickid%7D',
                            text: 'Go to Walmart'
                        }
                    ]
                    break
            }
        })

        return {
            welcomeMessage,
            partnerLogo,
            subtext,
            links,
            trackOutboundLink
        }
    }
})
</script>